<template>
  <div class="content">
    <div class="content__wrapper">
      <MainJumboPartial />
      <DepositCTAPartial ref="deposit" />
    </div>
    <IntroPartial />
    <NewMortgageJumboPartial />
    <ImproveMortgageJumboPartial />
    <CalculatorBannerPartial />
    <ReviewsPartial />
    <!--<Platforms />-->
    <BanksCarousel />
    <FunnelRecall />
    <FooterContact />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { onMounted, ref } from '@vue/composition-api';
import { onResize } from '@/lego/utils/window/screen';
import { getTouchedScreen } from '@/lego/utils/tailwind/screen';
import MainJumboPartial from '@/lego/partials/home/MainJumbo.vue';
import DepositCTAPartial from '@/lego/partials/home/DepositCTA.vue';
import NewMortgageJumboPartial from '@/lego/partials/home/NewMortgageJumbo.vue';
import ImproveMortgageJumboPartial from '@/lego/partials/home/ImproveMortgageJumbo.vue';
import ReviewsPartial from '@/lego/partials/home/reviews/Reviews.vue';
import BanksCarousel from '@/lego/partials/home/BanksCarousel.vue';
import FunnelRecall from '@/lego/partials/home/FunnelRecall.vue';
//import Platforms from '@/lego/partials/home/Platforms.vue';
import IntroPartial from '@/lego/partials/home/Intro.vue';
import CalculatorBannerPartial from '@/lego/partials/home/CalculatorBanner.vue';
import FooterContact from '@/lego/partials/FooterContact.vue';

export default {
  components: {
    MainJumboPartial,
    DepositCTAPartial,
    NewMortgageJumboPartial,
    ImproveMortgageJumboPartial,
    ReviewsPartial,
    BanksCarousel,
    FunnelRecall,
    //Platforms,
    IntroPartial,
    CalculatorBannerPartial,
    FooterContact,
  },
  setup() {
    const deposit = ref(null);
    const breakpoints = { xs: true, lg: false };
    const hideOnScroll = ref(false);

    const prevScrollY = ref(0);
    const depositPosition = ref(0);

    const updateBreakpoint = () => {
      const screen = getTouchedScreen(breakpoints);
      hideOnScroll.value = breakpoints[screen];
    };

    window.addEventListener('scroll', debounce(() => {
      if (!hideOnScroll.value) return;

      const scrollDown = window.scrollY > prevScrollY.value && window.scrollY > 0;
      const depositHidden = depositPosition.value.bottom < window.scrollY;
      prevScrollY.value = window.scrollY;

      deposit.value.$el.style.opacity = (scrollDown && depositHidden) ? '0' : '1';
      deposit.value.$el.style.position = scrollDown ? 'absolute' : 'fixed';
    }));

    onMounted(() => {
      updateBreakpoint();

      depositPosition.value = deposit.value.$el.getBoundingClientRect();
    });
    onResize(() => {
      updateBreakpoint();
    });

    return {
      deposit,
    };
  },
};
</script>

<style scoped lang="postcss">
.content {
  &__wrapper {
    @apply flex flex-col-reverse lg:flex-col pt-[6rem] md:pt-[8.25rem] lg:pt-0;
  }
}
</style>